(function () {
  const init = () => {
    const mediaGallery = document.querySelector('media-gallery');
    if (!mediaGallery || mediaGallery.dataset.customMediaInit) return;
    mediaGallery.dataset.customMediaInit = '1';

    const thumbList = mediaGallery.querySelector('.thumbnail-list');
    const sliderRoot = mediaGallery.querySelector('slider-component:not(.thumbnail-slider)');

    // ── 1. Wrap-around cho nút < > ảnh chính ──
    mediaGallery
      .querySelectorAll('slider-component:not(.thumbnail-slider) .slider-button')
      .forEach((btn) => {
        const nb = btn.cloneNode(true);
        btn.parentNode.replaceChild(nb, btn);
        nb.removeAttribute('disabled');
        nb.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const dir = nb.name === 'next' ? 1 : -1;
          const thumbs = mediaGallery.querySelectorAll('.thumbnail-list__item .thumbnail');
          if (!thumbs.length) return;
          let i = Array.prototype.findIndex.call(thumbs, (t) => t.getAttribute('aria-current') === 'true');
          if (i === -1) i = 0;
          thumbs[(i + dir + thumbs.length) % thumbs.length].click();
        });
      });

    // ── 2. Auto-scroll thumb active (rAF tránh forced reflow) ──
    if (thumbList) {
      let rafId = 0;
      const scrollActive = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const active = thumbList.querySelector('.thumbnail[aria-current="true"]');
          if (!active) return;
          const item = active.closest('.thumbnail-list__item') || active;
          const lr = thumbList.getBoundingClientRect();
          const ir = item.getBoundingClientRect();
          if (ir.top < lr.top) {
            thumbList.scrollBy({ top: ir.top - lr.top - 4, behavior: 'smooth' });
          } else if (ir.bottom > lr.bottom) {
            thumbList.scrollBy({ top: ir.bottom - lr.bottom + 4, behavior: 'smooth' });
          }
        });
      };
      new MutationObserver((muts) => {
        for (const m of muts) if (m.attributeName === 'aria-current') { scrollActive(); break; }
      }).observe(thumbList, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
      scrollActive();
    }

    // ── 3. Mở khoá disabled REACTIVE (thay setInterval) ──
    if (sliderRoot) {
      new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.attributeName === 'disabled' && m.target.classList?.contains('slider-button')) {
            m.target.removeAttribute('disabled');
          }
        }
      }).observe(sliderRoot, { subtree: true, attributes: true, attributeFilter: ['disabled'] });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();